import React from 'react';
import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { Plan } from '../../hooks/api/user';

interface StudentPlanSelectProps {
  planId?: string;
  plans: Plan[];
  fullWidth?: boolean;
  onChange: (event: SelectChangeEvent) => void;
}

export default function StudentPlanSelect({
  planId,
  plans,
  fullWidth,
  onChange,
}: StudentPlanSelectProps) {
  return (
    <Select
      value={planId ?? 'no plan'}
      onChange={onChange}
      className="plan-select"
      size="small"
      fullWidth={fullWidth}
    >
      <MenuItem value="no plan">Sin plan</MenuItem>
      {plans.map((plan) => (
        <MenuItem key={plan.id} value={plan.id}>
          {plan.name}
        </MenuItem>
      ))}
    </Select>
  );
}
